import { useEffect, useState } from 'react';

const LOADER_MIN_DURATION = 100;

export const useMinDurationLoading = ({
	isLoading,
	minDuration = LOADER_MIN_DURATION,
}: {
	isLoading?: boolean;
	minDuration?: number;
	delay?: number;
}) => {
	const [isMinLoading, setIsMinLoading] = useState(false);

	useEffect(() => {
		if (!isLoading) {
			return;
		}

		setIsMinLoading(true);

		setTimeout(() => {
			setIsMinLoading(false);
		}, minDuration);
	}, [isLoading]);

	return { showLoader: isMinLoading || isLoading };
};
